import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="app-footer">
      <p>&copy; 2026 Cureiosity. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
